export default __webpack_public_path__ + "static/media/linkedin.70c3575d.svg";